module.exports = __webpack_public_path__ + "static/img/p.36d26574.png";